import { NgModule } from '@angular/core';
import { AboutDialogModule } from './components/about-dialog/about-dialog.module';
import { AccessDialogModule } from './components/access-dialog/access-dialog.module';
import { AddTeamModelDialogModule } from './components/add-team-model-dialog/add-team-model-dialog.module';
import { BackgroundColorDialogModule } from './components/background-color-dialog/background-color-dialog.module';
import { ClipboardDialogModule } from './components/clipboard-dialog/clipboard-dialog.module';
import { ConfirmDialogModule } from './components/confirm-dialog/confirm-dialog.module';
import { DomainJoinDialogModule } from './components/domain-join-dialog/domain-join-dialog.module';
import { GroupRestrictionDialogModule } from './components/group-restriction-dialog/group-restriction-dialog.module';
import { LegacyDialogModule } from './components/legacy-dialog/legacy-dialog.module';
import { LimitDialogModule } from './components/limit-dialog/limit-dialog.module';
import { NpsDialogModule } from './components/nps-dialog/nps-dialog.module';
import { SaveBookmarkDialogModule } from './components/save-bookmark-dialog/save-bookmark-dialog.module';
import { SaveModuleDialogModule } from './components/save-module-dialog/save-module-dialog.module';
import { WelcomeTourDialogModule } from './components/welcome-tour-dialog/welcome-tour-dialog.module';
import { ImportModelDialogModule } from './components/import-model-dialog/import-model-dialog.module';
import { DialogState } from './state/dialog.state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      DialogState
    ]),

    AboutDialogModule,
    AccessDialogModule,
    AddTeamModelDialogModule,
    BackgroundColorDialogModule,
    ClipboardDialogModule,
    ConfirmDialogModule,
    DomainJoinDialogModule,
    GroupRestrictionDialogModule,
    LegacyDialogModule,
    LimitDialogModule,
    NpsDialogModule,
    SaveBookmarkDialogModule,
    SaveModuleDialogModule,
    WelcomeTourDialogModule,
    ImportModelDialogModule
  ],
  exports: [
    AboutDialogModule,
    AccessDialogModule,
    AddTeamModelDialogModule,
    BackgroundColorDialogModule,
    ClipboardDialogModule,
    ConfirmDialogModule,
    DomainJoinDialogModule,
    GroupRestrictionDialogModule,
    LegacyDialogModule,
    LimitDialogModule,
    NpsDialogModule,
    SaveBookmarkDialogModule,
    SaveModuleDialogModule,
    WelcomeTourDialogModule,
    ImportModelDialogModule
  ]
})
export class DialogModule { }
